const React = require('react');

const Container = require('../common/Container.jsx');
const Content = require('../common/Content.jsx');
const _TypeConfig = require('../common/TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

function Items(props) {
    const data = props.data || {};
    const config = props.config || {};
    let blockProps = {};
    let formatProps = {};
    let includes = {};
    let metaProps = {};
    if (config.Config) {
        if (config.Config.Block) {
            blockProps = config.Config.Block;
        }
        if (config.Config.Format) {
            formatProps = config.Config.Format;
        }
        if (config.Config.Includes) {
            includes = config.Config.Includes;
        }
        if (config.Config.Meta) {
            metaProps = config.Config.Meta;
        }
    }
    let colSpan = 3;
    if (includes.Quantity) {
        colSpan++;
    }
    if (data.HasItemDiscount) {
        colSpan++;
    }

    let borderStyle;
    if (!Utilities.isNullOrWhitespace(blockProps.borderTop)) {
        borderStyle = { borderBottom: blockProps.borderTop };
    }
    if (!Utilities.isNullOrWhitespace(blockProps.lineSpacingTableHeader)) {
        borderStyle = borderStyle || {};
        borderStyle.paddingTop = blockProps.lineSpacingTableHeader;
    }
    let borderTop;
    if (borderStyle) {
        borderTop = <tr><td colSpan={colSpan} style={borderStyle} /></tr>;
    }

    borderStyle = undefined;
    if (!Utilities.isNullOrWhitespace(blockProps.borderBottom)) {
        borderStyle = { borderBottom: blockProps.borderBottom };
    }
    if (!Utilities.isNullOrWhitespace(blockProps.borderBottomSpacing)) {
        borderStyle = borderStyle || {};
        borderStyle.paddingTop = blockProps.borderBottomSpacing;
    }
    let borderBottom;
    if (borderStyle) {
        borderBottom = <tr><td colSpan={colSpan} style={borderStyle} /></tr>;
    }

    let tableHeader;
    if (includes.TableHeader) {
        let styleTableHeader = Utilities.Config.getStyle(data, blockProps, 'TableHeader');
        if (!Utilities.isNullOrWhitespace(blockProps.backgroundColorTableHeader)) {
            styleTableHeader.backgroundColor = blockProps.backgroundColorTableHeader;
        }
        if (blockProps.styleTableHeader == 'body') {
            styleTableHeader = Utilities.Config.getBodyStyle(data, styleTableHeader);
        } else {
            styleTableHeader = Utilities.Config.getHeaderStyle(data, styleTableHeader);
        }
        if (!Utilities.isNullOrWhitespace(blockProps.colorTableHeader)) {
            styleTableHeader.color = blockProps.colorTableHeader;
        }
        const styleDiscount = { textAlign: 'center' };
        const styleItem = { textAlign: 'center' };
        if (!Utilities.isNullOrWhitespace(blockProps.marginLeft)) {
            styleItem.paddingLeft = blockProps.marginLeft;
        }
        const stylePrice = { textAlign: 'right' };
        const styleQuantity = { textAlign: 'center' };
        const styleSubtotal = { textAlign: 'right' };
        if (!Utilities.isNullOrWhitespace(styleTableHeader.fontFamily)) {
            styleDiscount.fontFamily = styleTableHeader.fontFamily;
            styleItem.fontFamily = styleTableHeader.fontFamily;
            stylePrice.fontFamily = styleTableHeader.fontFamily;
            styleQuantity.fontFamily = styleTableHeader.fontFamily;
            styleSubtotal.fontFamily = styleTableHeader.fontFamily;
        }
        if (!Utilities.isNullOrWhitespace(styleTableHeader.fontSize)) {
            styleDiscount.fontSize = styleTableHeader.fontSize;
            styleItem.fontSize = styleTableHeader.fontSize;
            stylePrice.fontSize = styleTableHeader.fontSize;
            styleQuantity.fontSize = styleTableHeader.fontSize;
            styleSubtotal.fontSize = styleTableHeader.fontSize;
        }
        if (!Utilities.isNullOrWhitespace(styleTableHeader.lineHeight)) {
            styleDiscount.lineHeight = styleTableHeader.lineHeight;
            styleItem.lineHeight = styleTableHeader.lineHeight;
            stylePrice.lineHeight = styleTableHeader.lineHeight;
            styleQuantity.lineHeight = styleTableHeader.lineHeight;
            styleSubtotal.lineHeight = styleTableHeader.lineHeight;
        }
        tableHeader = (
            <tr style={styleTableHeader}>
                <Content.ValueWrapperCell columnSpacing={blockProps.columnSpacing} style={styleItem}>Item</Content.ValueWrapperCell>
                {
                    includes.Quantity &&
                    <Content.ValueWrapperCell columnSpacing={blockProps.columnSpacing} style={styleQuantity}>Quantity</Content.ValueWrapperCell>
                }
                <Content.ValueWrapperCell columnSpacing={blockProps.columnSpacing} style={stylePrice}>Price</Content.ValueWrapperCell>
                {
                    data.HasItemDiscount &&
                    <Content.ValueWrapperCell columnSpacing={blockProps.columnSpacing} style={styleDiscount}>Discount</Content.ValueWrapperCell>
                }
                <Content.ValueWrapperCell columnSpacing={blockProps.marginRight} style={styleSubtotal}>Subtotal</Content.ValueWrapperCell>
            </tr>
        );
    }

    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            onClick={props.onClick}
            onDragStart={props.onDragStart}>
            {tableHeader}
            {borderTop}
            {
                data.Inventory &&
                data.Inventory.map((d, i) =>
                    <LineItem
                        key={i}
                        blockProps={blockProps}
                        builder={props.builder}
                        collateralType={props.collateralType}
                        count={data.Inventory.length}
                        data={data}
                        formatProps={formatProps}
                        hasItemDiscount={data.HasItemDiscount}
                        includes={includes}
                        index={i}
                        item={d}
                        metaProps={metaProps} />
                )
            }
            {borderBottom}
            {
                props.builder &&
                (!data.Inventory || (data.Inventory && data.Inventory.length == 0)) &&
                <tr>
                    <td>
                        {
                            !includes.TableHeader &&
                            Utilities.Builder.emptyBlockPlaceholder()
                        }
                        {Utilities.Builder.dragOutline()}
                    </td>
                </tr>
            }
        </Container>
    )
}

function LineItem(props) {
    const includes = props.includes || {};
    const data = props.data || {};
    const item = props.item || {};

    const identifiers = [];
    if (includes.Number && item.Number && !isNaN(item.Number)) {
        identifiers.push(`Inv# ${item.Number}`);
    }
    if (includes.SKU && !Utilities.isNullOrWhitespace(item.SKU)) {
        identifiers.push(`SKU: ${item.SKU}`);
    }
    const metaProps = props.metaProps || {};
    const subtitle = Utilities.Inventory.getSubtitle(item, metaProps.editionSeparateLine != true, includes.Date);
    const editionInfo = Utilities.Inventory.getEditionNumberWithFormat(item, metaProps.formatEditionLimited, metaProps.formatEditionUnlimited);
    let formatStringDiscountCurrency, formatStringDiscountPercent, formatStringPrice, formatStringSubtotal;
    if (props.index == 0) {
        formatStringDiscountCurrency = props.formatProps.currencyFormatDiscountFirst;
        formatStringDiscountPercent = props.formatProps.percentFormatDiscountFirst;
        formatStringPrice = props.formatProps.currencyFormatPriceFirst
        formatStringSubtotal = props.formatProps.currencyFormatSubtotalFirst;
    } else {
        formatStringDiscountCurrency = props.formatProps.currencyFormatDiscount;
        formatStringDiscountPercent = props.formatProps.percentFormatDiscount;
        formatStringPrice = props.formatProps.currencyFormatPrice;
        formatStringSubtotal = props.formatProps.currencyFormatSubtotal;
    }
    let localization;
    if (data.Gallery) {
        localization = data.Gallery.Localization;
    }

    let itemDiscount;
    if (props.hasItemDiscount) {
        if (item.Discount == 0) {
            itemDiscount = metaProps.textZeroDiscount;
        } else if (item.DiscountType == 2) {
            itemDiscount = Utilities.Format.Currency.getDisplayString(item.Discount, formatStringDiscountCurrency, localization);
        } else {
            itemDiscount = Utilities.Format.Percent.getDisplayString(item.Discount, formatStringDiscountPercent);
        }
    }
    const blockProps = props.blockProps || {};
    const style = { pageBreakInside: 'avoid' };
    if (!Utilities.isNullOrWhitespace(blockProps.color)) {
        style.color = blockProps.color;
    }
    if (!Utilities.isNullOrWhitespace(blockProps.fontSize)) {
        style.fontSize = blockProps.fontSize;
    }
    if (!Utilities.isNullOrWhitespace(blockProps.fontWeight)) {
        style.fontWeight = blockProps.fontWeight;
    }
    if (!Utilities.isNullOrWhitespace(blockProps.lineHeight)) {
        style.lineHeight = blockProps.lineHeight;
    }
    const cellStyle = { verticalAlign: 'top' };
    if (props.index == 0 && !Utilities.isNullOrWhitespace(blockProps.borderTopSpacing)) {
        cellStyle.paddingTop = blockProps.borderTopSpacing;
    }
    if (props.index != props.count - 1 && !Utilities.isNullOrWhitespace(blockProps.lineItemSpacing)) {
        cellStyle.paddingBottom = blockProps.lineItemSpacing;
    }

    const styleArtist = Utilities.Config.getStyle(data, metaProps, 'Artist');
    if (!Utilities.isNullOrWhitespace(metaProps.marginLeftArtist)) {
        styleArtist.paddingLeft = metaProps.marginLeftArtist;
    }
    const styleTitle = Utilities.Config.getStyle(data, metaProps, 'Title');
    styleTitle.marginBottom = undefined;
    if (!Utilities.isNullOrWhitespace(metaProps.marginLeftTitle)) {
        styleTitle.paddingLeft = metaProps.marginLeftTitle;
    }
    let styleMedium;
    if (includes.Medium) {
        styleMedium = Utilities.Config.getStyle(data, metaProps, 'Medium');
        styleMedium.marginBottom = undefined;
        if (!Utilities.isNullOrWhitespace(metaProps.marginLeftMedium)) {
            styleMedium.paddingLeft = metaProps.marginLeftMedium;
        }
        if (!Utilities.isNullOrWhitespace(metaProps.lineSpacingTitle)) {
            styleMedium.marginTop = metaProps.lineSpacingTitle
        }
    }
    const hasMedium = includes.Medium && !Utilities.isNullOrWhitespace(item.Medium);
    let styleSignaturePlacement;
    if (includes.SignaturePlacement) {
        styleSignaturePlacement = Utilities.Config.getStyle(data, metaProps, 'SignaturePlacement');
        styleSignaturePlacement.marginBottom = undefined;
        if (!Utilities.isNullOrWhitespace(metaProps.marginLeftSignaturePlacement)) {
            styleSignaturePlacement.paddingLeft = metaProps.marginLeftSignaturePlacement;
        }
        if (!Utilities.isNullOrWhitespace(metaProps.lineSpacingTitle)) {
            styleSignaturePlacement.marginTop = metaProps.lineSpacingTitle
        }
        const marginTop = hasMedium ? metaProps.lineSpacingMedium : metaProps.lineSpacingTitle;
        if (!Utilities.isNullOrWhitespace(marginTop)) {
            styleSignaturePlacement.marginTop = marginTop;
        }
    }
    const hasSignaturePlacement = includes.SignaturePlacement && !Utilities.isNullOrWhitespace(item.Signature);
    let styleDimensions;
    if (includes.Dimensions) {
        styleDimensions = Utilities.Config.getStyle(data, metaProps, 'Dimensions');
        styleDimensions.marginBottom = undefined;
        if (!Utilities.isNullOrWhitespace(metaProps.marginLeftDimensions)) {
            styleDimensions.paddingLeft = metaProps.marginLeftDimensions;
        }
        let marginTop;
        if (hasSignaturePlacement) {
            marginTop = metaProps.lineSpacingSignaturePlacement;
        } else if (hasMedium) {
            marginTop = metaProps.lineSpacingMedium;
        } else {
            marginTop = metaProps.lineSpacingTitle;
        }
        if (!Utilities.isNullOrWhitespace(marginTop)) {
            styleDimensions.marginTop = marginTop;
        }
    }
    const hasDimensions = includes.Dimensions && !Utilities.isNullOrWhitespace(item.Dimensions);
    let styleAlternateDimensions;
    if (includes.AlternateDimensions) {
        styleAlternateDimensions = Utilities.Config.getStyle(data, metaProps, 'AlternateDimensions');
        styleAlternateDimensions.marginBottom = undefined;
        if (!Utilities.isNullOrWhitespace(metaProps.marginLeftAlternateDimensions)) {
            styleAlternateDimensions.paddingLeft = metaProps.marginLeftAlternateDimensions;
        }
        let marginTop;
        if (hasDimensions) {
            marginTop = metaProps.lineSpacingDimensions;
        } else if (hasSignaturePlacement) {
            marginTop = metaProps.lineSpacingSignaturePlacement;
        } else if (hasMedium) {
            marginTop = metaProps.lineSpacingMedium;
        } else {
            marginTop = metaProps.lineSpacingTitle;
        }
        if (!Utilities.isNullOrWhitespace(marginTop)) {
            styleAlternateDimensions.marginTop = marginTop;
        }
    }
    const hasAlternateDimensions = includes.AlternateDimensions && !Utilities.isNullOrWhitespace(item.AlternateDimensions);
    let styleEdition;
    if (metaProps.editionSeparateLine == true) {
        styleEdition = Utilities.Config.getStyle(data, metaProps, 'Edition');
        styleEdition.marginBottom = undefined;
        if (!Utilities.isNullOrWhitespace(metaProps.marginLeftEdition)) {
            styleEdition.paddingLeft = metaProps.marginLeftEdition;
        }
        let marginTop;
        if (hasAlternateDimensions) {
            marginTop = metaProps.lineSpacingAlternateDimensions;
        } else if (hasDimensions) {
            marginTop = metaProps.lineSpacingDimensions;
        } else if (hasSignaturePlacement) {
            marginTop = metaProps.lineSpacingSignaturePlacement;
        } else if (hasMedium) {
            marginTop = metaProps.lineSpacingMedium;
        } else {
            marginTop = metaProps.lineSpacingTitle;
        }
        if (!Utilities.isNullOrWhitespace(marginTop)) {
            styleEdition.marginTop = marginTop;
        }
    }
    const hasEditionLine = metaProps.editionSeparateLine == true && !Utilities.isNullOrWhitespace(editionInfo);
    let styleSKU;
    if (identifiers.length > 0) {
        let marginTop;
        if (hasEditionLine) {
            marginTop = metaProps.lineSpacingEdition;
        } else if (hasAlternateDimensions) {
            marginTop = metaProps.lineSpacingAlternateDimensions;
        } else if (hasDimensions) {
            marginTop = metaProps.lineSpacingDimensions;
        } else if (hasSignaturePlacement) {
            marginTop = metaProps.lineSpacingSignaturePlacement;
        } else if (hasMedium) {
            marginTop = metaProps.lineSpacingMedium;
        } else {
            marginTop = metaProps.lineSpacingTitle;
        }
        styleSKU = Utilities.Config.getStyle(data, metaProps, 'SKU');
        styleSKU.marginBottom = undefined;
        if (!Utilities.isNullOrWhitespace(marginTop)) {
            styleSKU.marginTop = marginTop;
        }
        if (!Utilities.isNullOrWhitespace(metaProps.marginLeftSKU)) {
            styleSKU.paddingLeft = metaProps.marginLeftSKU;
        }
    }
    let quantity;
    if (includes.Quantity) {
        const style = Utilities.Config.getStyle(data, metaProps, 'Quantity', { textAlign: 'center', width: '10%', ...cellStyle });
        quantity = <Content.ValueWrapperCell columnSpacing={blockProps.columnSpacing} style={style}>{item.Quantity}</Content.ValueWrapperCell>
    }
    let price;
    if (includes.RetailIfNoDiscount != false || (includes.RetailIfNoDiscount == false && item.Discount != 0)) {
        price = Utilities.Format.Currency.getDisplayString(item.Price, formatStringPrice, localization);
    }
    const stylePrice = Utilities.Config.getStyle(data, metaProps, 'Price', { textAlign: 'right', whiteSpace: 'pre-wrap', width: '15%', ...cellStyle });
    price = <Content.ValueWrapperCell columnSpacing={blockProps.columnSpacing} style={stylePrice}>{price}</Content.ValueWrapperCell>
    
    let discount;
    if (props.hasItemDiscount) {
        const style = Utilities.Config.getStyle(data, metaProps, 'Discount', { textAlign: 'center', whiteSpace: 'pre-wrap', width: '15%', ...cellStyle });
        discount = <Content.ValueWrapperCell columnSpacing={blockProps.columnSpacing} style={style}>{itemDiscount}</Content.ValueWrapperCell>
    }
    const styleSubtotal = Utilities.Config.getStyle(data, metaProps, 'Subtotal', { textAlign: 'right', whiteSpace: 'pre-wrap', width: '15%', ...cellStyle });
    const styleImage = { left: '0', maxWidth: '100%', top: '0' };
    const styleImageContainer = { height: '100px', textAlign: 'center', verticalAlign: 'top', width: '100px' };
    if (props.collateralType == 1) {
        // PDF
        styleImage.position = 'absolute';
        styleImageContainer.position = 'absolute';
    } else {
        styleImageContainer.float = 'left';
    }
    const styleDetails = { marginLeft: '100px', minHeight: '100px', verticalAlign: 'top' };
    const styleDetailsCell = { textAlign: 'left', width: '60%', ...cellStyle };
    if (!Utilities.isNullOrWhitespace(blockProps.columnSpacing)) {
        styleDetails.paddingLeft = blockProps.columnSpacing;
        styleDetailsCell.paddingRight = blockProps.columnSpacing;
    }
    if (!Utilities.isNullOrWhitespace(blockProps.marginLeft)) {
        styleDetailsCell.paddingLeft = blockProps.marginLeft;
    }
    return (
        <tr style={style}>
            <td style={styleDetailsCell}>
                <div>
                    <div style={styleImageContainer}>
                        {
                            item.ImageUrl && !Utilities.isNullOrWhitespace(item.ImageUrl) &&
                            <img alt={item.Title || ''} src={item.ImageUrl} style={styleImage} />
                        }
                    </div>
                    <div style={styleDetails}>
                        {
                            !Utilities.isNullOrWhitespace(item.ArtistName) &&
                            <div style={styleArtist}>{item.ArtistName}</div>
                        }
                        <div style={styleTitle}><em>{item.Title}</em>{subtitle}</div>
                        {
                            hasMedium &&
                            <div style={styleMedium}>{item.Medium}</div>
                        }
                        {
                            hasSignaturePlacement &&
                            <div style={styleSignaturePlacement}>{item.Signature}</div>
                        }
                        {
                            hasDimensions &&
                            <div style={styleDimensions}>{item.Dimensions}</div>
                        }
                        {
                            hasAlternateDimensions &&
                            <div style={styleAlternateDimensions}>{item.AlternateDimensions}</div>
                        }
                        {
                            hasEditionLine &&
                            <div style={styleEdition}>{editionInfo}</div>
                        }
                        {
                            identifiers.length > 0 &&
                            <div style={styleSKU}>{identifiers.join(' | ')}</div>
                        }
                    </div>
                </div>
                {props.index == 0 && props.builder && Utilities.Builder.dragOutline()}
            </td>
            {quantity}
            {price}
            {discount}
            <Content.ValueWrapperCell className="item_subtotal" columnSpacing={blockProps.marginRight} style={styleSubtotal}>{Utilities.Format.Currency.getDisplayString(item.Subtotal, formatStringSubtotal, localization)}</Content.ValueWrapperCell>
        </tr>
    )
}

const TypeConfig = {
    panel: {
        block: function () {
            return {
                label: 'Block Configuration',
                options: [
                    { display: 'Table Header Properties', id: 'tableHeaderProps', type: 'header' },
                    ..._TypeConfig.options.text({ name: 'TableHeader' }, {}, {}, {}),
                    {
                        display: 'Background Color',
                        name: 'backgroundColorTableHeader',
                        type: 'text',
                        value: '#eaeaea'
                    },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Table Properties', id: 'tableProps', type: 'header' },
                    {
                        display: 'Row Spacing',
                        name: 'lineItemSpacing',
                        type: 'text'
                    },
                    {
                        display: 'Column Spacing',
                        name: 'columnSpacing',
                        type: 'text'
                    },
                    {
                        display: 'Margin Left',
                        name: 'marginLeft',
                        type: 'text'
                    },
                    {
                        display: 'Margin Right',
                        name: 'marginRight',
                        type: 'text'
                    },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ..._TypeConfig.options.border()
                ]
            };
        },
        format: function () {
            return {
                expanded: false,
                label: 'Advanced',
                options: [
                    { display: 'Price Format', id: 'priceProps', type: 'header' },
                    _TypeConfig.options.currency({ display: 'First Item Price Currency Format', name: 'PriceFirst' }),
                    _TypeConfig.options.currency({ display: 'Price Currency Format', includeHelpText: false, name: 'Price' }),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Discount Format', id: 'discountProps', type: 'header' },
                    _TypeConfig.options.currency({ display: 'First Item Discount Currency Format', name: 'DiscountFirst' }),
                    _TypeConfig.options.currency({ display: 'Discount Currency Format', includeHelpText: false, name: 'Discount' }),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    _TypeConfig.options.percent({ display: 'First Item Discount Percent Format', fullWidth: true, name: 'DiscountFirst' }),
                    _TypeConfig.options.percent({ display: 'Discount Percent Format', fullWidth: true, includeHelpText: false, name: 'Discount' }),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Subtotal Format', id: 'subtotalProps', type: 'header' },
                    _TypeConfig.options.currency({ display: 'First Item Subtotal Currency Format', name: 'SubtotalFirst' }),
                    _TypeConfig.options.currency({ display: 'Subtotal Currency Format', includeHelpText: false, name: 'Subtotal' })
                ]
            };
        },
        includes: function () {
            return {
                expanded: false,
                label: 'Include',
                options: [
                    { display: 'Table Header', name: 'TableHeader', type: 'checkbox', value: true },
                    { display: 'Date Created', name: 'Date', type: 'checkbox', value: true, configurableDuringExport: function () { return true; } },
                    { display: 'Medium', name: 'Medium', type: 'checkbox', value: true },
                    { display: 'Signature Placement', name: 'SignaturePlacement', type: 'checkbox', value: true, configurableDuringExport: function () { return true; } },
                    { display: 'Dimensions', name: 'Dimensions', type: 'checkbox', value: true, configurableDuringExport: function () { return true; } },
                    { display: 'Alternate Dimensions', name: 'AlternateDimensions', type: 'checkbox', value: true, configurableDuringExport: function () { return true; } },
                    { display: 'Inventory Number', name: 'Number', type: 'checkbox', value: true, configurableDuringExport: function () { return true; } },
                    { display: 'SKU', name: 'SKU', type: 'checkbox', value: true, configurableDuringExport: function () { return true; } },
                    { display: 'Quantity', name: 'Quantity', type: 'checkbox', value: true },
                    { display: 'Retail If No Discount', name: 'RetailIfNoDiscount', type: 'checkbox', value: true }
                ]
            };
        },
        meta: function () {
            const editionVisibility = function (config) {
                return config.Meta && config.Meta.editionSeparateLine == true;
            }
            return {
                expanded: false,
                label: 'Line Item Configuration',
                options: [
                    { display: 'Artist Label Properties', id: 'artistProps', type: 'header' },
                    ..._TypeConfig.options.text({ name: 'Artist' }, {}, {}, {}),
                    {
                        display: 'Left Margin',
                        name: 'marginLeftArtist',
                        type: 'text'
                    },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Item Title Label Properties', id: 'titleProps', type: 'header' },
                    ..._TypeConfig.options.text({ name: 'Title' }, undefined, {}, {}),
                    {
                        display: 'Left Margin',
                        name: 'marginLeftTitle',
                        type: 'text'
                    },
                    {
                        display: 'Show Edition Info on Separate Line',
                        fullWidth: true,
                        name: 'editionSeparateLine',
                        type: 'checkbox'
                    },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Medium Label Properties', id: 'mediumProps', type: 'header' },
                    ..._TypeConfig.options.text({ name: 'Medium' }, {}, {}, {}),
                    {
                        display: 'Left Margin',
                        name: 'marginLeftMedium',
                        type: 'text'
                    },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Signature Placement Label Properties', id: 'signaturePlacementProps', type: 'header' },
                    ..._TypeConfig.options.text({ name: 'SignaturePlacement' }, {}, {}, {}),
                    {
                        display: 'Left Margin',
                        name: 'marginLeftSignaturePlacement',
                        type: 'text'
                    },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Dimensions Label Properties', id: 'dimensionsProps', type: 'header' },
                    ..._TypeConfig.options.text({ name: 'Dimensions' }, {}, undefined, {}),
                    {
                        display: 'Left Margin',
                        name: 'marginLeftDimensions',
                        type: 'text'
                    },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Alternate Dimensions Label Properties', id: 'alternateDimensionsProps', type: 'header' },
                    ..._TypeConfig.options.text({ name: 'AlternateDimensions' }, {}, undefined, {}),
                    {
                        display: 'Left Margin',
                        name: 'marginLeftAlternateDimensions',
                        type: 'text'
                    },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Edition Info Properties', id: 'editionProps', type: 'header' },
                    {
                        display: 'Limited Edition Display Format',
                        fullWidth: true,
                        helpText: () => 'Keywords: [EditionNumber], [EditionCount]',
                        name: 'formatEditionLimited',
                        type: 'format',
                        value: 'Edition [EditionNumber]/[EditionCount]',
                        visible: editionVisibility
                    },
                    {
                        display: 'Unlimited Edition Display Format',
                        fullWidth: true,
                        helpText: () => 'Keywords: [EditionNumber]',
                        name: 'formatEditionUnlimited',
                        type: 'format',
                        value: 'Edition [EditionNumber]',
                        visible: editionVisibility
                    },
                    ..._TypeConfig.options.text({ name: 'Edition', visible: editionVisibility }, {}, undefined, {}),
                    {
                        display: 'Left Margin',
                        name: 'marginLeftEdition',
                        type: 'text',
                        visible: editionVisibility
                    },
                    {
                        type: 'spacer',
                        visible: editionVisibility
                    },
                    {
                        type: 'spacer',
                        visible: editionVisibility
                    },
                    { display: 'Inv#/SKU Label Properties', id: 'skuProps', type: 'header' },
                    ..._TypeConfig.options.text({ name: 'SKU' }, {}),
                    {
                        display: 'Left Margin',
                        name: 'marginLeftSKU',
                        type: 'text'
                    },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Quantity Label Properties', id: 'quantityProps', type: 'header' },
                    ..._TypeConfig.options.text({ name: 'Quantity' }, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Price Label Properties', id: 'priceProps', type: 'header' },
                    ..._TypeConfig.options.text({ name: 'Price' }, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Discount Label Properties', id: 'discountProps', type: 'header' },
                    ..._TypeConfig.options.text({ name: 'Discount' }, {}),
                    {
                        display: 'Display When Zero',
                        name: 'textZeroDiscount',
                        type: 'text',
                        value: '0'
                    },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Subtotal Label Properties', id: 'subtotalProps', type: 'header' },
                    ..._TypeConfig.options.text({ name: 'Subtotal' }, {})
                ]
            };
        },
        style: function () { return _TypeConfig.panel.layoutStyle(); }
    }
};

module.exports = {
    Component: Items,
    TypeConfig
};